<template>
  <div class="alert-error" id="alert-error">
    <div class="alert-error__content">
      <div class="alert-error__content-text">

        {{text}}

        <span v-if="moreText">
           <br> {{ moreText }}
         </span>
      </div>

      <div class="alert-error__content-buttons">

        <div class="alert-error__button-grow"
             @click="clickGrowButtonPopup()"
        >
          <span>{{ buttonText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      default: ''
    },
    moreText: {
      default: false
    },
    buttonText: {
      default: 'ок'
    }
  },
  methods: {
    async clickCancelPopup() {
      this.$emit('clickCancelPopup')
    },
    async clickDeletePopup() {
      this.$emit('clickDeletePopup')
    },
    async clickGrowButtonPopup() {
      this.$emit('clickGrowButtonPopup')
    }
  }
}
</script>

<style lang="less">
.alert-error {
  width: 100vw;
  height: 100vh;
  position: absolute;
  min-height: 430px;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.alert-error__content {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  padding: 14px 20px;
  border-radius: 13px;
  max-width: 343px;
  width: 100%;
}

@import '~/assets/fonts/roboto/Roboto-Medium.less';

.alert-error__content-text {
  text-align: center;
  font-size: 15px;
  color: #31283D;
  font-family: 'Roboto-Medium';
}

.alert-error__content-buttons {
  display: flex;
  margin-top: 16px;
  align-items: center;
  justify-content: center;
}

@import '~/assets/fonts/montserrat/Montserrat-Medium.less';


.alert-error__button-grow {
  height: 44px;
  width: 95%;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #674FFD;
  border-radius: 5px;
  color: #FFFFFF;
  text-align: center;
  font-size: 16px;
  line-height: 12px;
  font-family: 'Montserrat-Medium';
}
</style>